/**
 * Context-aware replacements for antd's static `message` / `notification`.
 *
 * antd 5 static functions (imported from 'antd') render outside the React
 * tree, so they can't consume ConfigProvider theme and warn:
 *   "Static function can not consume context like dynamic theme."
 *
 * Umi's antd plugin (config `antd.appConfig`) already wraps the app in
 * antd's <App>, which provides context-bound instances via App.useApp().
 * <AntdStaticBridge /> (mounted once in app.tsx childrenRender) captures
 * those instances into this module's live bindings; import `message` /
 * `notification` from here instead of from 'antd'.
 *
 * The antd statics remain as initial fallbacks so calls that fire before
 * the bridge mounts still work.
 */
import {
  App,
  message as staticMessage,
  notification as staticNotification,
} from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';
import type { NotificationInstance } from 'antd/es/notification/interface';

let message: MessageInstance = staticMessage;
let notification: NotificationInstance = staticNotification;

const AntdStaticBridge: React.FC = () => {
  const app = App.useApp();
  message = app.message;
  notification = app.notification;
  return null;
};

export default AntdStaticBridge;
export { message, notification };
